import type { TrackType } from "../../vendor/src/features/remotion-editor/editor/state/types";
import type { EditorStarterItem } from "../../vendor/src/features/remotion-editor/editor/items/item-type";
export type TrackKind = "video" | "caption" | "audio";
export const itemTrackKind = (item: EditorStarterItem): TrackKind =>
  item.type === "audio"
    ? "audio"
    : item.type === "captions" ||
        (item.type === "text" && item.renderMeta?.clipType === "caption")
      ? "caption"
      : "video";
export const trackKind = (track: TrackType): TrackKind =>
  track.zone === "audio"
    ? "audio"
    : track.metadata?.type === "caption" || track.metadata?.type === "captions"
      ? "caption"
      : "video";
/** Stable partition: audio has no visual z-order, so moving it below visuals preserves the composition. */
export function orderTrackZones(tracks: TrackType[]): TrackType[] {
  const sorted = [
    ...tracks.filter((t) => t.zone !== "audio"),
    ...tracks.filter((t) => t.zone === "audio"),
  ];
  return sorted.every((t, i) => t === tracks[i]) ? tracks : sorted;
}
export function trackLabels(tracks: TrackType[]): string[] {
  let video = tracks.filter((t) => trackKind(t) === "video").length,
    caption = 0,
    audio = 0;
  return tracks.map((t) =>
    trackKind(t) === "audio"
      ? `A${++audio}`
      : trackKind(t) === "caption"
        ? `C${++caption}`
        : `V${video--}`,
  );
}

/** Chronological non-overlapping blocks, original paint order within overlapping graphics. */
export function orderTrackBlocks(
  ids: string[],
  items: Record<string, EditorStarterItem>,
): string[] {
  const clusters = new Map<string, number>();
  let end = -Infinity,
    cluster = -1;
  for (const id of [...ids].sort((a, b) => items[a]!.from - items[b]!.from)) {
    const item = items[id]!;
    if (item.from >= end) {
      cluster++;
      end = item.from + item.durationInFrames;
    } else end = Math.max(end, item.from + item.durationInFrames);
    clusters.set(id, cluster);
  }
  return [...ids].sort((a, b) => clusters.get(a)! - clusters.get(b)!);
}
